export default __webpack_public_path__ + "static/mp-394b0c91d8212a6cb6db896dcbd08758.svg";